import { MessageCircle, Instagram, Linkedin } from "lucide-react";
import { scrollToSection, waLink, SPECIALIST_MESSAGE } from "../lib/config";

export default function Footer() {
  const go = (href) => (e) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-gold/15 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10 relative">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img
              src="/pulse-logo.png"
              alt="Pulse Saúde — Marketing & Tecnologia"
              className="h-14 w-auto"
              data-testid="footer-logo"
            />
            <p className="mt-6 text-sm text-bone/50 leading-relaxed max-w-xs">
              Ecossistema completo de crescimento para clínicas de saúde e estética:
              captação, comercial, tecnologia e educação.
            </p>
            <div className="mt-6 flex gap-3">
              <a href="#" data-testid="footer-social-instagram" aria-label="Instagram" className="w-10 h-10 rounded-full border border-gold/25 flex items-center justify-center text-bone/60 hover:text-gold hover:border-gold transition-colors">
                <Instagram size={17} />
              </a>
              <a href="#" data-testid="footer-social-linkedin" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-gold/25 flex items-center justify-center text-bone/60 hover:text-gold hover:border-gold transition-colors">
                <Linkedin size={17} />
              </a>
              <a href={waLink(SPECIALIST_MESSAGE)} target="_blank" rel="noopener noreferrer" data-testid="footer-social-whatsapp" aria-label="WhatsApp" className="w-10 h-10 rounded-full border border-gold/25 flex items-center justify-center text-bone/60 hover:text-gold hover:border-gold transition-colors">
                <MessageCircle size={17} />
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-gold font-semibold mb-6">Navegação</p>
            <ul className="space-y-3.5 text-sm">
              {[
                ["Método Pulse", "#metodo"],
                ["Soluções", "#solucoes"],
                ["Pulse Hub", "#hub"],
                ["Pulse Academy", "#academy"],
                ["Resultados", "#resultados"],
                ["Diagnóstico gratuito", "#diagnostico"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} onClick={go(href)} data-testid={`footer-link-${href.slice(1)}`} className="text-bone/55 hover:text-gold transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-gold font-semibold mb-6">Contato</p>
            <a
              href={waLink(SPECIALIST_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-cta"
              className="inline-flex items-center gap-3 bg-gold text-ink font-display font-bold text-sm px-6 py-3 rounded-full hover:bg-bone transition-colors"
            >
              <MessageCircle size={16} />
              Falar no WhatsApp
            </a>
            <p className="mt-6 text-xs text-bone/40 leading-relaxed max-w-xs">
              Atendimento para clínicas de saúde e estética em todo o Brasil.
            </p>
          </div>
        </div>

        <p
          aria-hidden="true"
          className="mt-16 font-display font-extrabold text-[18vw] leading-none text-center text-bone/[0.035] select-none pointer-events-none tracking-tight"
        >
          PULSE
        </p>

        <div className="mt-4 pt-8 border-t border-bone/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-bone/35">
            © {new Date().getFullYear()} Pulse Saúde — Marketing & Tecnologia. Todos os direitos reservados.
          </p>
          <p className="text-xs text-bone/35" data-testid="footer-lgpd-note">
            Dados tratados conforme a LGPD (Lei nº 13.709/2018).
          </p>
        </div>
      </div>
    </footer>
  );
}
